//MainToolbar.tsx ==============================================================
import "../Util/Prototypes";

import * as Carousel from "../Util/Carousel";
import * as Default from "../Default";
import * as DrawerMenu from "../Menus/DrawerMenu";
import * as Settings from "../Settings";
import * as SnackBar from "../Util/SnackBar";
import * as Util from "../Util/Util";
import * as Util_App from "../Util/Util_App";
import * as Widgets from "../Widgets/Widgets";

import { Button, ButtonGroup, CssBaseline, Fab, Icon } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";

import React from "react";
import ReactDOM from "react-dom/client";

let showFabs: boolean;
let showButtons: boolean;
let showIconButtons: boolean;
let root: ReactDOM.Root;

//Render all components in the html content div.
export function render() {
   Util.logMsg('Building MainToolbar react components.');

   if (!root) {
      root = ReactDOM.createRoot(document.getElementById("toolbarDiv"));
   }
   root.render(<MainToolbarComponent />);
}

//Add or remove the 3D button.
export function addOrRemove3D() {
   Settings.setEnabled3D(false);
   Settings.mainToolbarTools.Remove("Dim_2D_3D");
   const i: number = Settings.mainToolbarTools.IndexOfNoCase("Print");
   let add3D: boolean = false;

   if (Settings.security.accessLevel >= Settings.accessLevel3D) {
      if (Util_App.isWebMercator()) {
         add3D = true;

      } else {
         for (const em of Settings.elevMaps) {
            if (!em.isGlobal) {
               add3D = true;
            }
         }
      }
   }

   if (add3D) {
      Settings.setEnabled3D(true);

      if (i !== -1) {
         Settings.mainToolbarTools.InsertAt(i, "Dim_2D_3D");
      } else {
         Settings.mainToolbarTools.Add("Dim_2D_3D");
      }
   }
}

// MainToolbar component. =======================================================
interface iProps {
}

//Render function.
function MainToolbarComponent(props: iProps) {
   //Util.logMsg("Top of MainToolbar Render");

   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   //Component did mount.
   React.useEffect(() => {
      Util.logMsg('MainToolbar did mount');
      Widgets.setPosition(); //Set the widget positions on website startup part 1.
   }, []);

   //Get buttons.
   function getButtons(buttonType: string): JSX.Element[] {
      const styles: Default.iStyles = {
         fab: { marginRight: 7, marginTop: 3 },
         button: { paddingLeft: 8, paddingRight: 8 },
      };

      const toolNames: string[] = Settings.mainToolbarTools;

      //Remove some of the tools on a phone.
      if (Settings.isPhone) {
         for (const tool of Settings.mainToolbarToolsOmitOnPhone) {
            toolNames.Remove(tool);
         }
      }

      const jsx: JSX.Element[] = [];

      for (const toolName of toolNames) {
         if (!toolName.startsWith(" ")) {
            const ti: Settings.iToolInfo = Settings.getToolInfo(toolName);

            if (buttonType === "Fab") {
               jsx.push(
                  <Fab key={Util.uid()} style={styles.fab} size="small" color="primary" onClick={() => DrawerMenu.showTool(toolName)} title={ti.tip} aria-label={toolName}>
                     <Icon style={{ color: ti.iconColorToolbar }}>{ti.iconName}</Icon>
                  </Fab>,
               );

            } else if (buttonType === "Button") {
               jsx.push(
                  <Button key={Util.uid()} style={styles.button} onClick={() => DrawerMenu.showTool(toolName)} title={ti.tip} aria-label={ti.label}>
                     {ti.label}
                  </Button>,
               );

            } else {
               jsx.push(
                  <Button key={Util.uid()} style={styles.button} onClick={() => DrawerMenu.showTool(toolName)} title={ti.tip} aria-label={ti.label}>
                     <Icon style={{ fontSize: 17, color: ti.iconColorToolbar }}>{ti.iconName}</Icon>
                     <span style={{ marginLeft: 4 }}></span>
                     {ti.label}
                  </Button>,
               );
            }
         }
      }
      return jsx;
   }

   const width: number = Util.windowWidth();

   showFabs = false;
   showButtons = false;
   showIconButtons = false;

   // Custom! Use these values if you add another button.
   // if (width <= 825) {
   // } else if (width > 825 && width < 1010) {

   if (width <= 780) {
      showFabs = true;

   } else if (width > 780 && width < 940) {
      showButtons = true;

   } else {
      showIconButtons = true;
   }

   return (
      <ThemeProvider theme={Default.theme}>
         <CssBaseline />
         {showFabs && getButtons("Fab")}

         {(showButtons || showIconButtons) &&
            <ButtonGroup variant="contained" color="primary" aria-label="Main toolbar buttons">
               {showButtons && getButtons("Button")}
               {showIconButtons && getButtons("IconButton")}
            </ButtonGroup>
         }
         <SnackBar.Render />
         <Carousel.Render />
      </ThemeProvider>
   ); //end return.

} //end function.
